export function similarity(s1, s2) {
  let longer = s1;
  let shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  let longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (
    (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength)
  );
}

function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  let costs = new Array();
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= s2.length; j++) {
      if (i == 0) costs[j] = j;
      else {
        if (j > 0) {
          let newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}

export function removeHtmlTags(html: string) {
  if (!html) return '';
  let strippedString = html.replace(/(<([^>]+)>)/gi, '');
  strippedString = strippedString.replaceAll('&amp;', '&');
  strippedString = strippedString.replaceAll('&lt;', '<');
  strippedString = strippedString.replaceAll('&gt;', '>');
  strippedString = strippedString.replaceAll('&nbsp;', ' ');
  strippedString = strippedString.replaceAll('&quot;', '"');
  strippedString = strippedString.replaceAll('&apos;', "'");
  strippedString = strippedString.replaceAll('&copy;', '(c)');
  strippedString = strippedString.replaceAll('&reg;', '(r)');
  strippedString = strippedString.replaceAll('&trade;', '(tm)');
  return strippedString;
}

export function getAllowedTextForUrl(section: string): string {
  if (!isAllSymbolAllowedForUrl(section)) {
    let symbols = section.toString().split('');
    let newText = '';
    for (let symbol of symbols) {
      if (isAllSymbolAllowedForUrl(symbol)) {
        newText += symbol;
      }
    }
    section = newText;
  }
  return section;
}

function isAllSymbolAllowedForUrl(str) {
  if (!str) {
    return true;
  }
  return new RegExp('^[-+A-Za-z_0-9 ]+$').test(str);
}
